// Seasonal specials — single source of truth for banner, popup, homepage section, /fall-ready and /winter-ready.
// Windows are America/Denver (MST = UTC-7 in winter): the site switches automatically at midnight.
//   Fall Fix-Up Special   : now → Nov 30, 2026 23:59:59 MST  (ends Dec 1 2026 07:00 UTC)
//   Winter Fix-Up Special : Dec 1, 2026 → Jan 31, 2027 23:59:59 MST (ends Feb 1 2027 07:00 UTC)
//   Afterwards            : no discount — "Get Your Home Ready for Spring — Request a Free Estimate."
// QA: append ?promo_preview=fall | winter | expired to any URL to force a state.
const PHONE = { phoneDisplay: '(505) 219-7816', phoneTel: 'tel:+15052197816' };

export const SPECIALS = {
  fall: {
    ...PHONE,
    key: 'fall-special-2026',
    season: 'fall',
    promoParam: 'fall-special',
    promoLabel: 'Fall Special',
    path: '/fall-ready',
    title: 'Fall Fix-Up Special',
    tagline: 'Get Your Home Ready for Winter!',
    intro: 'Take care of repairs before colder weather and refresh your home before the holidays.',
    offer: 'Save 10% on labor — up to $300 — on qualifying projects booked by November 30, 2026.',
    offerShort: 'Save 10% on labor — up to $300',
    deadlineLabel: 'November 30, 2026',
    terms: 'Materials excluded. Cannot be combined with other offers. Mention “Fall Special” when requesting your estimate. Exterior work is subject to suitable weather.',
    ctaText: 'Get My Fall Estimate',
    bannerText: 'Fall Fix-Up Special — Save 10% on labor (up to $300) through Nov 30!',
    badgeText: 'Limited time · Book by Nov 30',
    flyer: '/fall-special-flyer.png',
    flyerWebp: '/fall-special-flyer.webp',
    ogImage: 'https://aqualityhandyman.com/fall-special-og.jpg',
    printPdf: '/api/promo/fall-special/flyer.pdf',
    theme: { gradient: 'from-red-900 via-orange-800 to-amber-700', banner: 'from-red-800 via-orange-700 to-amber-600', glow: 'bg-amber-400/20', accent: 'text-amber-300', soft: 'text-amber-50/90', fine: 'text-amber-100/80', label: 'text-amber-200', light: 'bg-amber-50', card: 'border-amber-200' },
    groups: [
      { key: 'winter-prep', title: 'Winter Preparation', items: 'Door adjustments, weatherstripping, caulking, and gutter repairs.', photo: '/projects/doors-carpentry/aqh-albuquerque-doors-carpentry-decks-001.webp' },
      { key: 'exterior', title: 'Exterior Repairs', items: 'Stucco cracks, soffit, fascia, and damaged trim.', photo: '/projects/exterior-stucco/aqh-albuquerque-exterior-stucco-painting-001.webp' },
      { key: 'holiday', title: 'Holiday Refresh', items: 'Interior painting, drywall repairs, and home repair lists.', photo: '/projects/interior-remodeling/aqh-albuquerque-interior-painting-remodel-001.webp' },
    ],
    groupsHeading: 'Three Ways to Get Ready for Winter',
    groupsIntro: 'Real projects from our Albuquerque crew — repairs before the cold, exterior fixes while the weather allows, and a fresh interior before guests arrive.',
    startsUtc: 0,
    endsUtc: Date.UTC(2026, 11, 1, 7, 0, 0),
  },
  winter: {
    ...PHONE,
    key: 'winter-special-2026',
    season: 'winter',
    promoParam: 'winter-special',
    promoLabel: 'Winter Special',
    path: '/winter-ready',
    title: 'Winter Fix-Up Special',
    tagline: 'Get Your Home Winter Ready!',
    intro: 'Stop drafts, protect pipes and knock out the indoor project list while the weather keeps you home.',
    offer: 'Save $50 on labor on projects over $500 booked by January 31, 2027.',
    offerShort: 'Save $50 on labor on projects over $500',
    deadlineLabel: 'January 31, 2027',
    terms: 'Materials excluded. Cannot be combined with other offers. Mention “Winter Special” when requesting your estimate. Exterior work is subject to suitable weather.',
    ctaText: 'Get My Winter Estimate',
    bannerText: 'Winter Fix-Up Special — Save $50 on labor on projects over $500 through Jan 31!',
    badgeText: 'Limited time · Book by Jan 31',
    flyer: '/winter-special-flyer.png',
    flyerWebp: '/winter-special-flyer.webp',
    ogImage: 'https://aqualityhandyman.com/winter-special-og.jpg',
    printPdf: '/api/promo/winter-special/flyer.pdf',
    theme: { gradient: 'from-slate-900 via-blue-900 to-sky-800', banner: 'from-slate-900 via-blue-800 to-sky-700', glow: 'bg-sky-300/20', accent: 'text-sky-300', soft: 'text-sky-50/90', fine: 'text-sky-100/80', label: 'text-sky-200', light: 'bg-sky-50', card: 'border-sky-200' },
    groups: [
      { key: 'draft-freeze', title: 'Draft & Freeze Protection', items: 'Weatherstripping, door sweeps, caulking, and pipe insulation.', photo: '/projects/doors-carpentry/aqh-albuquerque-doors-carpentry-decks-002.webp' },
      { key: 'indoor', title: 'Indoor Projects', items: 'Interior painting, drywall repairs, trim, and shelving.', photo: '/projects/interior-remodeling/aqh-albuquerque-interior-painting-remodel-002.webp' },
      { key: 'repair-list', title: 'Repair List', items: 'Gutter and roof-edge checks, fence and gate repairs, and your whole-home fix-it list.', photo: '/projects/exterior-stucco/aqh-albuquerque-exterior-stucco-painting-002.webp' },
    ],
    groupsHeading: 'Three Ways to Stay Warm and Worry-Free',
    groupsIntro: 'Seal the cold out, tackle the indoor list and clear the repairs winter exposes — all from one trusted local crew.',
    startsUtc: Date.UTC(2026, 11, 1, 7, 0, 0),
    endsUtc: Date.UTC(2027, 1, 1, 7, 0, 0),
  },
};

// Shown when no special is running (after Jan 31, 2027)
const FALLBACK = {
  ...PHONE,
  key: 'no-special', season: 'none', promoParam: null, promoLabel: null, path: '/fall-ready',
  title: 'Get Your Home Ready for Spring', tagline: 'Request a Free Estimate', intro: 'Repairs, painting and the fix-it list — one call, one team, everything done right.',
  offer: null, terms: null, ctaText: 'Request a Free Estimate', bannerText: 'Get Your Home Ready for Spring — Request a Free Estimate.', badgeText: 'Proudly Serving Greater Albuquerque',
  flyer: '/winter-special-flyer.png', flyerWebp: '/winter-special-flyer.webp', ogImage: 'https://aqualityhandyman.com/winter-special-og.jpg', printPdf: null,
  theme: SPECIALS.winter.theme, groups: SPECIALS.winter.groups, groupsHeading: 'Popular Projects', groupsIntro: 'A few of the ways we help homeowners across the greater Albuquerque area.',
  startsUtc: 0, endsUtc: Infinity,
};

const previewParam = () => { try { return new URLSearchParams(window.location.search).get('promo_preview'); } catch (e) { return null; } };

// The special for right now (or a forced preview). `active` = discount currently valid.
export const getSpecial = (now = Date.now()) => {
  const p = previewParam();
  if (p === 'fall') return { ...SPECIALS.fall, active: true };
  if (p === 'winter') return { ...SPECIALS.winter, active: true };
  if (p === 'expired') return { ...FALLBACK, active: false };
  const live = Object.values(SPECIALS).find((s) => now >= s.startsUtc && now < s.endsUtc);
  return live ? { ...live, active: true } : { ...FALLBACK, active: false };
};

// Map a ?promo= value to its label, only while that special is live
export const promoLabelForParam = (param) => {
  const s = getSpecial();
  return s.active && s.promoParam === param ? s.promoLabel : null;
};
